import { useState } from 'react';

interface SubMenuItem {
  label: string;
  href: string;
}

interface MenuItem {
  label: string;
  href: string;
  subItems?: SubMenuItem[];
}

const menuItems: MenuItem[] = [
  {
    label: 'HOME',
    href: '/'
  },
  {
    label: 'ABOUT US',
    href: '#',
    subItems: [
      { label: 'OUR STORY', href: '/about/' },
      { label: 'CERTIFICATIONS', href: '/certifications/' },
      { label: 'TESTIMONIALS', href: '/testimonials/' },
      { label: 'NEWS', href: '/news/' }
    ]
  },
  {
    label: 'SERVICES',
    href: '#',
    subItems: [
      { label: 'AVIONICS', href: '/avionics/' },
      { 
        label: 'PAINTING', 
        href: '/painting/',
        // Note: PAINTING has a sub-submenu for RECENT PROJECTS but keeping it simple for now
      },
      { label: 'MAINTENANCE', href: '/maintenance/' },
      { label: 'PARTS', href: '/parts/' },
      { label: 'AIRCRAFT STC\'s', href: '/aircraft-stcs/' }
    ]
  },
  {
    label: '24-HOUR AOG',
    href: '/24hr-aog-service/'
  },
  {
    label: 'LOCATIONS',
    href: '/locations/'
  },
  {
    label: 'SWAG',
    href: '/swag/'
  },
  {
    label: 'CONTACT US',
    href: '/contact/',
    subItems: [
      { label: 'EMPLOYMENT', href: '/employment/' }
    ]
  }
];

export function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav 
      className="relative z-50"
      style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8))`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Mobile menu button */}
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center p-2 text-white hover:bg-gray-700 focus:outline-none"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="sr-only">Open main menu</span>
            <div className="space-y-1">
              <span className="block text-xs font-medium">MENU</span>
            </div>
          </button>

          {/* Desktop navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {menuItems.map((item) => (
                <div key={item.label} className="relative group">
                  <a
                    href={item.href}
                    className={`text-white hover:bg-gray-700 hover:text-white px-3 py-2 text-sm font-medium transition-colors duration-200 flex items-center gap-1 ${
                      item.label === 'CONTACT US' ? 'bg-blue-800 hover:bg-blue-900 rounded' : ''
                    }`}
                  >
                    {item.label}
                    {item.subItems && (item.label === 'ABOUT US' || item.label === 'SERVICES') && (
                      <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    )}
                  </a>
                  
                  {/* Dropdown menu */}
                  {item.subItems && (
                    <div className="absolute left-0 mt-2 w-56 bg-gray-900 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                      <div className="py-2">
                        {item.subItems.map((subItem) => (
                          <a
                            key={subItem.label}
                            href={subItem.href}
                            className="block px-4 py-2 text-sm text-white hover:bg-gray-700 transition-colors duration-200"
                          >
                            {subItem.label}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 bg-gray-900">
            {menuItems.map((item) => (
              <div key={item.label}>
                <a
                  href={item.href}
                  className="text-white hover:bg-gray-700 block px-3 py-2 text-base font-medium"
                >
                  {item.label}
                </a>
                {item.subItems && (
                  <div className="pl-4">
                    {item.subItems.map((subItem) => (
                      <a
                        key={subItem.label}
                        href={subItem.href}
                        className="text-gray-300 hover:text-white hover:bg-gray-700 block px-3 py-2 text-sm"
                      >
                        {subItem.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}